module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_search_photographer-b967d5cb8330f915d9e67237052de533.svg";